export const DEBUG_RENDERER = false;
export const DEBUG_EVENTS = false;
export const debug = DEBUG_RENDERER ? console.log : () => { };
export const TEXT_BASE_SIZE = 12;
export const DEFAULT_FONT_SIZE = 50;
export const Z_INC = 0.001;
export const COLLIDER_THICKNESS = 0.05;
